import React, { useRef, useEffect, useState } from "react";
import { VariableSizeList } from "react-window";
import { styled } from "@mui/material/styles";

const LISTBOX_PADDING = 8; // padding do listbox do Autocomplete
const DEFAULT_ITEM_HEIGHT = 56;

const StyledListItem = styled("li")({
  wordBreak: "break-word", // permite a quebra de linha para palavras longas
  whiteSpace: "normal", // garante que o texto quebre em várias linhas
  padding: "8px", // padding interno para melhorar a aparência
});

const renderRow = ({ data, index, style }) => {
  const { ref, ...rest } = data[index];
  return (
    <StyledListItem
      {...rest.props}
      style={{ ...style, top: style.top + LISTBOX_PADDING }}
      ref={ref}
    >
      {rest.props.children}
    </StyledListItem>
  );
};

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemCount = React.Children.count(children);

  const itemRefs = useRef([]);
  if (itemRefs.current.length !== itemCount) {
    itemRefs.current = Array(itemCount)
      .fill()
      .map((_, i) => itemRefs.current[i] || React.createRef());
  }

  const itemData = React.Children.toArray(children).map((child, index) => ({
    ...child,
    ref: itemRefs.current[index],
  }));

  const [heights, setHeights] = useState(
    new Array(itemCount).fill(DEFAULT_ITEM_HEIGHT)
  );

  useEffect(() => {
    const newHeights = itemData.map((child, index) => {
      const element = child.ref.current;
      return element ? element.getBoundingClientRect().height : 36;
    });
    setHeights(newHeights);
  }, [itemCount, children]); // Only run when children change

  const getItemSize = () => DEFAULT_ITEM_HEIGHT;

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={
            Math.min(8, itemCount) * DEFAULT_ITEM_HEIGHT + 2 * LISTBOX_PADDING
          }
          width="100%"
          outerElementType={OuterElementType}
          itemSize={getItemSize}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

export default ListboxComponent;
